import React, { Dispatch, SetStateAction } from 'react';

export interface ISidebarContext {
  sidebarOpen: boolean;
  search: string;
  setSidebarOpen: Dispatch<SetStateAction<boolean>>;
  setSearch: Dispatch<SetStateAction<string>>;
}

const SidebarContext = React.createContext<ISidebarContext>({
  sidebarOpen: true,
  search: '',
  setSidebarOpen: () => {},
  setSearch: () => {},
});

export default SidebarContext;
